import { put } from 'redux-saga/effects'
import { setActiveChatAction } from '../../handles'
import { delay } from '@/redux/department/sagas/setDepartmentSaga/helpers'

export function* setActiveChatSaga(action: ReturnType<typeof setActiveChatAction.request>) {
  const { activeChat } = action.payload
  try {
    yield delay(1000)
    yield put(setActiveChatAction.success({ activeChat }))
  } catch (error) {
    yield put(setActiveChatAction.failure())
  }
}
